
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...wordpressCreditCardsEN]",
      function () {
        return require("private-next-pages/[...wordpressCreditCardsEN].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...wordpressCreditCardsEN]"])
      });
    }
  